export const calculateDiscount = (products) => {
  const totalPrice = products.reduce(
    (sum, product) => sum + parseFloat(product.renewal_variant.price),
    0,
  );

  const discount = parseFloat(totalPrice * 0.2).toFixed(2);
  const total = parseFloat(totalPrice - discount).toFixed(2);

  return {
    subtotal: totalPrice,
    displaySubtotal: `$${totalPrice.toFixed(2)}`,
    discount: parseFloat(discount),
    displayDiscount: `$${discount}`,
    total: parseFloat(total),
    displayTotal: `$${total}`,
  };
};

export const getOptionValue = (optionValues, name) =>
  optionValues.find((option) => option.option_type_name === name);

export const setShippingOptionMetadata = (products) =>
  products.map((product) => {
    const { renewal_variant: renewalVariant } = product;

    if (!renewalVariant) {
      return {
        ...product,
        shippingOption: null,
      };
    }

    const { name: productName } = renewalVariant;
    let isNetwork = false;
    let isUsbDongle = false;

    if (productName === 'Software Renewal') {
      const licenseTypeOptionValue = getOptionValue(
        renewalVariant.option_values,
        'license_type',
      );

      if (licenseTypeOptionValue) {
        const [activationMethod, numberOfUsers] =
          licenseTypeOptionValue.presentation.split(' - ');

        const licenseType =
          numberOfUsers === 'Single User' ? 'Standalone' : 'Network';

        isNetwork = licenseType === 'Network';
        isUsbDongle = activationMethod.toLowerCase().includes('usb');
      }
    } else {
      const activationMethod = getOptionValue(
        renewalVariant.option_values,
        'activation_method',
      );
      const licenseType = getOptionValue(
        renewalVariant.option_values,
        'license-type',
      );

      isUsbDongle = activationMethod?.name === 'usb-dongle';
      isNetwork = licenseType?.name === 'network';
    }

    // Shipping rules:
    // - network + USB dongle: shipping is required and locked on
    // - standalone + USB dongle: shipping defaults on and can be toggled by the user
    // - all other variants: no shipping toggle applies
    const isStandalone = !isNetwork;
    const isDigitalDelivery = !isUsbDongle;
    const includeShippingLocked = isUsbDongle && isNetwork;
    const canToggleIncludeShipping = isUsbDongle && isStandalone;
    const defaultIncludeShipping = includeShippingLocked || canToggleIncludeShipping ? true : undefined;

    return {
      ...product,
      shippingOption: {
        isUsbDongle,
        isStandalone,
        isDigitalDelivery,
        includeShippingLocked,
        canToggleIncludeShipping,
        defaultIncludeShipping,
      },
    };
  });
